import React, { useLayoutEffect, useRef, useState } from 'react';

// Description clamped to 2 lines with a "Περισσότερα"/"Λιγότερα" toggle — shown
// only when the text actually overflows.
//
// Shared by the payment and shipping method cards so both rows behave identically;
// lives in its own module rather than in either list to keep those two from
// importing each other.
// `lead` is an optional glyph rendered INSIDE the text flow, before the first
// word (the ⓘ on an unavailable method). Inline rather than a separate column so
// the sentence wraps around it and continues under it, and so it survives the
// -webkit-line-clamp used below — a flex/float child would not.
export default function ClampedDesc({ text, lead }) {
  const ref = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [overflow, setOverflow] = useState(false);
  useLayoutEffect(() => {
    const el = ref.current;
    if (el) setOverflow(el.scrollHeight > el.clientHeight + 1);
  }, [text]);
  return (
    <>
      <span ref={ref} className={`cn-method__desc ${expanded ? '' : 'is-clamped'}`}>{lead}{text}</span>
      {(overflow || expanded) && (
        <button
          type="button"
          className="cn-method__more"
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); setExpanded((v) => !v); }}
        >
          {expanded ? 'Λιγότερα' : 'Περισσότερα'}
        </button>
      )}
    </>
  );
}
